export type TMatchPart = {
  text: string;
  match: boolean;
};

/**
 * Splits a name around the first occurrence of a query so a result row can
 * mark what the visitor typed.
 *
 * The comparison lowercases both sides, so it is case-insensitive but not
 * accent-folding: "ore" does not match "Öre". The returned text keeps the
 * name's own casing. A query that is not in the name at all — a postal code,
 * which the search matches against a meta field — comes back as a single
 * unmarked part.
 */
export function highlightMatch(name: string, query: string): TMatchPart[] {
  const needle = query.trim().toLowerCase();
  const unmarked = [{ match: false, text: name }];

  if (!(needle && name)) {
    return unmarked;
  }

  const start = name.toLowerCase().indexOf(needle);

  if (start === -1) {
    return unmarked;
  }

  const end = start + needle.length;

  return [
    { match: false, text: name.slice(0, start) },
    { match: true, text: name.slice(start, end) },
    { match: false, text: name.slice(end) },
  ];
}
